import { useAppDispatch, useAppSelector } from 'app/config/store';
import { reset } from 'app/entities/truck-implement/truck-implement.reducer';
import TireChassisStructure from 'app/shared/components/tire-chassis-structure/tire-chassis-structure';
import React, { useEffect, useState } from 'react';
import { Translate } from 'react-jhipster';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import HeightIcon from '@mui/icons-material/Height';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import { Alert, Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { NoData } from 'app/shared/components/no-data/NoData';
import TireTableInfo from '../component/tire-table-detail';
import TireGrooveCustom from '../tire-groove-custom/tire-groove-custom';
import TireTruckImplementCustomAddDialog from './tire-truck-implement-custom-add-dialog';
import TireTruckImplementCustomRemoveDialog from './tire-truck-implement-custom-remove-dialog';
import TireTruckImplementCustomReplacementDialog from './tire-truck-implement-custom-replacement-dialog';
import { getTruckImplementNumberOfTires } from './tire-truck-implement-custom.reducer';

interface IProps {
  truckImplementId: number | string;
}

interface ITirePositions {
  position: number;
  steppe: boolean;
  selected: boolean;
}

const TireTruckImplementCustom = (props: IProps) => {
  const { truckImplementId } = props;
  const dispatch = useAppDispatch();

  const loading = useAppSelector(state => state.tireTruckImplementCustom.loading);
  const truckImplement = useAppSelector(state => state.truckImplement.entity);
  const tireTruckImplements = useAppSelector(state => state.tireTruckImplementCustom.entities);
  const truckImplementTireDataDTO = useAppSelector(state => state.tireTruckImplementCustom.truckImplementTireDataDTO);
  const [tirePositions, setTirePositions] = useState<ITirePositions[]>([]);

  useEffect(() => {
    dispatch(reset);
    dispatch(getTruckImplementNumberOfTires(truckImplementId));
  }, []);

  useEffect(() => {
    const dataPosition: ITirePositions[] = [];

    if (!dataPosition.length) {
      for (let i = 1; i <= truckImplementTireDataDTO.numberOfTires; i++) {
        dataPosition.push({ position: i, steppe: false, selected: true });
      }

      dataPosition.push({ position: dataPosition.length + 1, steppe: true, selected: true });
      dataPosition.push({ position: dataPosition.length + 1, steppe: true, selected: true });

      setTirePositions(dataPosition);
    }
  }, [truckImplementTireDataDTO]);

  const mapTireData = () => {
    return tirePositions.map(tire => {
      const isAdded = tireTruckImplements.some(item => item.position === tire.position);

      return {
        position: tire.position,
        steppe: tire.steppe,
        selected: isAdded ? true : false,
      };
    });
  };

  return (
    <div>
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <Box sx={{ textAlign: 'right' }}>
            {!loading && truckImplement.vehicleModel && tireTruckImplements.length < 1 && (
              <Box sx={{ textAlign: 'right' }}>
                <Button
                  component={Link}
                  to={`/tire-alert-state/tire-truck-implement-custom-update/${truckImplement.id}`}
                  variant="contained"
                  color="secondary"
                  startIcon={<AddIcon />}
                >
                  Realizar instalação dos pneus
                </Button>
              </Box>
            )}

            {!loading && !truckImplement.vehicleModel && (
              <Alert severity="info">
                <Box sx={{ mb: 2 }}>
                  O ativo precisa ter um <strong>modelo do ativo</strong> para realizar a instalação de pneus.
                </Box>
                <Button
                  component={Link}
                  to={`/truck-implement/${truckImplement.id}/edit`}
                  variant="contained"
                  color="info"
                  startIcon={<AddIcon />}
                >
                  <Translate contentKey="fleetSenseApp.vehicleModel.home.title" />
                </Button>
              </Alert>
            )}
          </Box>

          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 150, mt: 3 }}>
              <Typography sx={{ color: 'text.secondary' }}>Aguarde, carregando...</Typography>
            </Box>
          ) : tireTruckImplements && tireTruckImplements.length > 0 ? (
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} lg={6}>
                <Card sx={{ mb: 4 }}>
                  <CardContent>
                    <Typography variant="h5">
                      <Translate contentKey="fleetSenseApp.tire.home.title" />
                    </Typography>
                    <Box sx={{ textAlign: 'right', mb: 3 }}>
                      <TireTruckImplementCustomAddDialog /> <TireTruckImplementCustomReplacementDialog />{' '}
                      <TireTruckImplementCustomRemoveDialog />
                    </Box>
                    <TireTableInfo tireTruckImplements={tireTruckImplements.map(tire => tire)} />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md="auto" lg={3}>
                <Card>
                  <CardContent>
                    <Typography variant="h5">
                      <Translate contentKey="fleetSenseApp.tireGroove.home.title" />
                    </Typography>
                    <Box sx={{ textAlign: 'right', mb: 3 }}>
                      <Button
                        component={Link}
                        to={`/tire-alert-state/groove-measurement-update/${truckImplement.id}`}
                        variant="contained"
                        color="secondary"
                        startIcon={<HeightIcon />}
                      >
                        Medição de sulco
                      </Button>
                    </Box>
                    <TireGrooveCustom />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md="auto">
                <Card>
                  <CardContent>
                    <Typography variant="h5">Chassi</Typography>
                    <Box sx={{ textAlign: 'right', mb: 3 }}>
                      <Button
                        component={Link}
                        to={`/tire-alert-state/tire-truck-implement-custom-update/${truckImplement.id}`}
                        variant="contained"
                        color="secondary"
                        startIcon={<ShuffleIcon />}
                      >
                        Rodízio
                      </Button>
                    </Box>
                    <TireChassisStructure
                      vehicleType={tireTruckImplements[0]?.truckImplement?.vehicleModel?.type ?? ''}
                      tireData={mapTireData()}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          ) : (
            <NoData title="Não há pneus instalados no veículo" />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default TireTruckImplementCustom;
